'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowInCircle, iconArrowInCircleTag } from '@ni/nimble-components/dist/esm/icons/arrow-in-circle';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowInCircle };
export { iconArrowInCircleTag };
export const NimbleIconArrowInCircle = wrap(IconArrowInCircle);